export enum FeaturesRoutingEnum {
  Jobs = 'jobs',
  Help = 'help',
  Info = 'info',
  NotFound = '404',
  Interview = 'interview',
  Interviews = 'interviews',
  EventClosed = 'end',
}
